/**
 * @file ChartPopover 模块级常量：空选区、浮层尺寸、外点关闭白名单与自动关闭延迟。
 */
import type { RegionSelectValueType } from '@home/components/NewRegionSelect/type';
import { CHART_GAME_LIST_BUBBLE_OVERLAY_CLASS } from '../components/ChartGameSelect/bubbleOverlay';
import { CHART_TITLE_TIP_OVERLAY_CLASS } from '../components/ChartPopoverTitleTip';

/** NewRegionSelect 空选区初始值 */
export const EMPTY_VALUE: RegionSelectValueType = { type: '', regions: [], markets: [] };

/** 图表浮窗右侧列表固定宽度（px） */
export const CHART_POPOVER_RIGHT_LIST_WIDTH = 335;

/** 双栏列表区高度（默认 325，略收窄减少底部留白） */
export const CHART_POPOVER_CONTENT_HEIGHT = 285;

/** 右侧虚拟列表高度（content 285 − 标题行约 20） */
export const CHART_POPOVER_RIGHT_LIST_HEIGHT = 265;

/**
 * 外点关闭白名单 class 列表。
 * 包含浮窗本体、触发器、游戏下拉及各 Bubble portal，点击这些区域不触发关闭。
 */
export const CHART_POPOVER_INSIDE_SELECTORS = [
  /** 图表浮窗 overlay 根节点 */
  'dba-new-chart-popover-overlay',
  /** 图表按钮 Dropdown 触发器 */
  'dba-new-chart-popover-trigger',
  /** 旧版游戏 SingleSelect 下拉（兼容） */
  'dba-new-chart-select-overlay',
  /** 游戏选择主面板 */
  'dba-new-chart-game-panel-overlay',
  /** 游戏子版本下拉 */
  'dba-new-chart-game-sub-overlay',
  /** 经分子版本包裹层 */
  'dbd-sub-game-wrap',
  /** 列表行溢出 Bubble */
  'dba-new-chart-list-bubble',
  /** 搜索 tag 溢出 Bubble */
  'dba-new-chart-search-tag-bubble',
  /** 游戏列表行 tips Bubble */
  CHART_GAME_LIST_BUBBLE_OVERLAY_CLASS,
  /** 标题旁 ? 说明 Bubble */
  CHART_TITLE_TIP_OVERLAY_CLASS,
] as const;

/** 白名单选择器拼接串，供 `Element.closest` 批量匹配 */
export const CHART_POPOVER_INSIDE_CLOSEST = CHART_POPOVER_INSIDE_SELECTORS
  .map((sel) => `.${sel}`)
  .join(', ');

/** hover 离开触发器与浮层后的自动关闭延迟（ms），对齐 Skill/Agent 按钮 */
export const CHART_POPOVER_AUTO_CLOSE_DELAY_MS = 200;
